"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ButtonSocialIcon;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gatsby = require("gatsby");
var _utils = require("../../../utils/utils");
// Packages

// Components

// Utils

const {
  canHover
} = (0, _utils.getMediaQueries)();

// Styles
const ButtonIcon = _styledComponents.default.button.withConfig({
  displayName: "social__ButtonIcon",
  componentId: "sc-m34s01-0"
})(["background:transparent;border:none;cursor:pointer;svg{circle{fill:", ";stroke:", ";transition:all 0.2s ease-in-out;}path{fill:", ";stroke:", ";transition:all 0.2s ease-in-out;}}&:active,&:focus{svg{circle{fill:", ";stroke:", ";}path{fill:", ";stroke:", ";}}}", ""], props => props.$circleDefaultColor || undefined, props => props.$borderDefaultColor || undefined, props => props.$iconDefaultColor || undefined, props => props.$iconBorderDefaultColor || undefined, props => props.$circleActiveColor || _utils.colors["pacific-blue-2"].hex, props => props.$borderActiveColor || _utils.colors["pacific-blue-2"].hex, props => props.$iconActiveColor || undefined, props => props.$iconBorderActiveColor || undefined, canHover`
    :hover {
      svg {
        circle {
          fill: ${props => props.$circleActiveColor || _utils.colors["pacific-blue-2"].hex};
          stroke: ${props => props.$borderActiveColor || _utils.colors["pacific-blue-2"].hex};
        }
        path {
          fill: ${props => props.$iconActiveColor || undefined};
          stroke: ${props => props.$iconBorderActiveColor || undefined};
        }
      }
    }
  `);
function ButtonSocialIcon({
  circleDefaultColor,
  circleActiveColor,
  iconDefaultColor,
  iconActiveColor,
  borderDefaultColor,
  borderActiveColor,
  icon,
  iconBorderActiveColor,
  iconBorderDefaultColor,
  circleHeight,
  circleWidth,
  title,
  functions,
  linkAttributes
}) {
  let selectedIcon;
  switch (icon) {
    default:
    case "copy":
      selectedIcon = /*#__PURE__*/_react.default.createElement("svg", {
        width: circleWidth,
        height: circleHeight,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("title", null, title || "Copy"), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "14",
        cy: "14",
        r: "13.5",
        stroke: "#2D3748"
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "9",
        y: "10.042",
        width: "8.11189",
        height: "10.1399",
        rx: "0.506993",
        stroke: "#2D3748"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.042 9.78846V8.50699C11.042 8.22699 11.269 8 11.549 8H18.6469C18.9269 8 19.1539 8.22699 19.1539 8.50699V17.6329C19.1539 17.9129 18.9269 18.1399 18.6469 18.1399H17.1119",
        stroke: "#2D3748"
      }));
      break;
    case "facebook":
      selectedIcon = /*#__PURE__*/_react.default.createElement("svg", {
        width: circleWidth,
        height: circleHeight,
        viewBox: "0 0 29 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("title", null, title || "Facebook"), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "14.5",
        cy: "14",
        r: "13.5",
        stroke: "#5C6677"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.6667 14.3792H17.3333L18 11.8125H15.6667V10.5292C15.6667 9.86825 15.6667 9.24583 17 9.24583H18V7.08983C17.7827 7.06224 16.962 7 16.0953 7C14.2853 7 13 8.06324 13 10.0158V11.8125H11V14.3792H13V19.8333H15.6667V14.3792Z",
        fill: "#5C6677"
      }));
      break;
    case "instagram":
      selectedIcon = /*#__PURE__*/_react.default.createElement("svg", {
        width: circleWidth,
        height: circleHeight,
        viewBox: "0 0 29 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("title", null, title || "Instagram"), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "14.5",
        cy: "14",
        r: "13.5",
        stroke: "#5C6677"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 8.99982H12C10.6193 8.99982 9.5 10.1191 9.5 11.4998V16.4998C9.5 17.8805 10.6193 18.9998 12 18.9998H17C18.3807 18.9998 19.5 17.8805 19.5 16.4998V11.4998C19.5 10.1191 18.3807 8.99982 17 8.99982Z",
        stroke: "#5C6677",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16.5 13.6849C16.5617 14.101 16.4906 14.526 16.2969 14.8994C16.1031 15.2728 15.7965 15.5756 15.4208 15.7647C15.045 15.9539 14.6192 16.0197 14.2039 15.9529C13.7885 15.886 13.4049 15.6899 13.1074 15.3925C12.8099 15.095 12.6138 14.7113 12.547 14.296C12.4802 13.8807 12.546 13.4549 12.7351 13.0791C12.9243 12.7033 13.2271 12.3968 13.6005 12.203C13.9739 12.0093 14.3989 11.9382 14.815 11.9999C15.2394 12.0628 15.6324 12.2606 15.9358 12.5641C16.2392 12.8675 16.437 13.2604 16.5 13.6849Z",
        stroke: "#5C6677",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.25 11.2498H17.2563",
        stroke: "#5C6677",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
      break;
    case "link":
      selectedIcon = /*#__PURE__*/_react.default.createElement("svg", {
        width: circleWidth,
        height: circleHeight,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("title", null, title || "Link"), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "14",
        cy: "14",
        r: "13.5",
        stroke: "#2D3748"
      }), /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_1849_1562)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M13.0277 14.4863C13.2365 14.7654 13.5028 14.9963 13.8087 15.1634C14.1145 15.3305 14.4527 15.4299 14.8004 15.4548C15.148 15.4797 15.497 15.4295 15.8235 15.3077C16.1501 15.1859 16.4466 14.9953 16.693 14.7488L18.1513 13.2905C18.5941 12.8321 18.8391 12.2181 18.8335 11.5808C18.828 10.9435 18.5724 10.3339 18.1217 9.88328C17.6711 9.43264 17.0615 9.17702 16.4242 9.17148C15.7869 9.16594 15.1729 9.41093 14.7145 9.85367L13.8784 10.6849",
        stroke: "#2D3748",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.9713 13.514C14.7625 13.2349 14.4962 13.004 14.1903 12.8369C13.8845 12.6698 13.5463 12.5704 13.1986 12.5455C12.851 12.5206 12.5021 12.5708 12.1755 12.6926C11.849 12.8144 11.5524 13.005 11.306 13.2515L9.84769 14.7098C9.40495 15.1683 9.15996 15.7822 9.1655 16.4195C9.17103 17.0568 9.42665 17.6664 9.8773 18.117C10.3279 18.5677 10.9376 18.8233 11.5748 18.8288C12.2121 18.8344 12.8261 18.5894 13.2845 18.1467L14.1157 17.3154",
        stroke: "#2D3748",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_1849_1562"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "11.6667",
        height: "11.6667",
        fill: "white",
        transform: "translate(8.16675 8.16675)"
      }))));
      break;
    case "linkedin":
      selectedIcon = /*#__PURE__*/_react.default.createElement("svg", {
        width: circleWidth,
        height: circleHeight,
        viewBox: "0 0 29 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("title", null, title || "LinkedIn"), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "14.5",
        cy: "14",
        r: "13.5",
        stroke: "#5C6677"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.792 10.3131C11.7918 10.5728 11.6885 10.8219 11.5048 11.0055C11.321 11.1891 11.0719 11.2921 10.8121 11.292C10.5524 11.2918 10.3033 11.1885 10.1198 11.0048C9.93618 10.821 9.83312 10.5719 9.83325 10.3121C9.83338 10.0524 9.93669 9.80333 10.1204 9.61975C10.3042 9.43618 10.5534 9.33312 10.8131 9.33325C11.0728 9.33338 11.3219 9.43669 11.5055 9.62045C11.6891 9.80421 11.7921 10.0534 11.792 10.3131V10.3131ZM11.8214 12.0172H9.86263V18.148H11.8214V12.0172ZM14.9161 12.0172H12.9672V18.148H14.8966V14.9308C14.8966 13.1386 17.2323 12.9721 17.2323 14.9308V18.148H19.1666V14.2648C19.1666 11.2435 15.7094 11.3561 14.8966 12.8399L14.9161 12.0172V12.0172Z",
        fill: "#5C6677"
      }));
      break;
    case "twitter":
      selectedIcon = /*#__PURE__*/_react.default.createElement("svg", {
        width: circleWidth,
        height: circleHeight,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("circle", {
        cx: "14",
        cy: "14",
        r: "13.5",
        stroke: "#2D3748"
      }), /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_1850_1659)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M20 10.2785C19.5585 10.4745 19.084 10.6065 18.586 10.666C19.0945 10.3615 19.485 9.87902 19.6685 9.30402C19.193 9.58602 18.666 9.79102 18.105 9.90152C17.6565 9.42302 17.016 9.12402 16.308 9.12402C14.7185 9.12402 13.5505 10.607 13.9095 12.1465C11.864 12.044 10.05 11.064 8.8355 9.57452C8.1905 10.681 8.501 12.1285 9.597 12.8615C9.194 12.8485 8.814 12.738 8.4825 12.5535C8.4555 13.694 9.273 14.761 10.457 14.9985C10.1105 15.0925 9.731 15.1145 9.345 15.0405C9.658 16.0185 10.567 16.73 11.645 16.75C10.61 17.5615 9.306 17.924 8 17.77C9.0895 18.4685 10.384 18.876 11.774 18.876C16.345 18.876 18.9275 15.0155 18.7715 11.553C19.2525 11.2055 19.67 10.772 20 10.2785Z",
        fill: "#2D3748"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_1850_1659"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "12",
        height: "12",
        fill: "white",
        transform: "translate(8 8)"
      }))));
      break;
    case "web":
      selectedIcon = /*#__PURE__*/_react.default.createElement("svg", {
        width: circleWidth,
        height: circleHeight,
        viewBox: "0 0 29 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("circle", {
        cx: "14.5",
        cy: "14",
        r: "13.5",
        stroke: "#5C6677"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.5 19C17.2614 19 19.5 16.7614 19.5 14C19.5 11.2386 17.2614 9 14.5 9C11.7386 9 9.5 11.2386 9.5 14C9.5 16.7614 11.7386 19 14.5 19Z",
        stroke: "#5C6677",
        strokeWidth: "0.9",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.5 14H19.5",
        stroke: "#5C6677",
        strokeWidth: "0.9",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.5 9C15.7506 10.3692 16.4614 12.146 16.5 14C16.4614 15.854 15.7506 17.6308 14.5 19C13.2494 17.6308 12.5386 15.854 12.5 14C12.5386 12.146 13.2494 10.3692 14.5 9V9Z",
        stroke: "#5C6677",
        strokeWidth: "0.9",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
      break;
    case "zillow":
      selectedIcon = /*#__PURE__*/_react.default.createElement("svg", {
        width: circleWidth,
        height: circleHeight,
        viewBox: "0 0 29 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("title", null, title || "Zillow"), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "14.5",
        cy: "14",
        r: "13.5",
        stroke: "#5C6677"
      }), /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_532_159)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M16.2661 10.4663C16.3163 10.4551 16.3387 10.4719 16.3692 10.5054C16.5422 10.6981 17.0954 11.3746 17.2457 11.5591C17.2736 11.5926 17.2543 11.6292 17.2319 11.6486C16.1154 12.5207 14.8729 13.7563 14.1807 14.6397C14.1669 14.6595 14.1781 14.6595 14.1892 14.6565C15.3952 14.1365 18.2283 13.3061 19.5042 13.0742V11.4559L14.5105 7.50006L9.50818 11.4529V13.2222C11.0572 12.3001 14.6415 10.8714 16.2661 10.4663V10.4663Z",
        fill: "#5C6677"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.2008 17.2648C12.1592 17.2871 12.1252 17.2816 12.0917 17.248L11.1594 16.1354C11.1345 16.1044 11.1315 16.0877 11.165 16.0404C11.8856 14.9837 13.3565 13.3369 14.2944 12.6411C14.3112 12.6299 14.3056 12.6157 14.2858 12.6243C13.3088 12.943 10.5315 14.1394 9.50427 14.7209V18.5H19.5007V14.8607C18.1385 15.0925 14.0574 16.3087 12.2008 17.2648Z",
        fill: "#5C6677"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_532_159"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "10",
        height: "11",
        fill: "white",
        transform: "translate(9.50378 7.5)"
      }))));
      break;
  }
  return /*#__PURE__*/_react.default.createElement(ButtonIcon, Object.assign({}, functions, linkAttributes, {
    $circleDefaultColor: circleDefaultColor,
    $circleActiveColor: circleActiveColor,
    $iconDefaultColor: iconDefaultColor,
    $iconActiveColor: iconActiveColor,
    $borderDefaultColor: borderDefaultColor,
    $borderActiveColor: borderActiveColor,
    $iconBorderActiveColor: iconBorderActiveColor,
    $iconBorderDefaultColor: iconBorderDefaultColor,
    as: linkAttributes ? linkAttributes.href ? "a" : _gatsby.Link : "button"
  }), selectedIcon);
}
ButtonSocialIcon.propTypes = {
  /**
   * Name of icon
   */
  icon: _propTypes.default.string.isRequired,
  /**
   * Sets height of icon circle
   */
  circleHeight: _propTypes.default.number,
  /**
   * Sets width of icon circle
   */
  circleWidth: _propTypes.default.number,
  /**
   * Sets default color of icon circle
   */
  circleDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of icon circle
   */
  circleActiveColor: _propTypes.default.string,
  /**
   * Sets default color of icon
   */
  iconDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of icon
   */
  iconActiveColor: _propTypes.default.string,
  /**
   * Sets active color of icon border
   */
  iconBorderActiveColor: _propTypes.default.string,
  /**
   * Sets default color of icon border
   */
  iconBorderDefaultColor: _propTypes.default.string,
  /**
   * Sets default color of border around icon circle
   */
  borderDefaultColor: _propTypes.default.string,
  /**
   * Sets active color of border around icon circle
   */
  borderActiveColor: _propTypes.default.string,
  /**
   * Sets title of icon for accessibility
   */
  title: _propTypes.default.string,
  /**
   * Button Functions, e.g. { onClick: () => {}}
   */
  functions: _propTypes.default.shape(),
  /**
   * Link Attributes e.g. { to: "/", target: "_blank"}
   */
  linkAttributes: _propTypes.default.shape()
};
ButtonSocialIcon.defaultProps = {
  circleHeight: 40,
  circleWidth: 40
};
ButtonSocialIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ButtonSocialIcon",
  "props": {
    "circleHeight": {
      "defaultValue": {
        "value": "40",
        "computed": false
      },
      "description": "Sets height of icon circle",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "circleWidth": {
      "defaultValue": {
        "value": "40",
        "computed": false
      },
      "description": "Sets width of icon circle",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "icon": {
      "description": "Name of icon",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "circleDefaultColor": {
      "description": "Sets default color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "circleActiveColor": {
      "description": "Sets active color of icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconDefaultColor": {
      "description": "Sets default color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconActiveColor": {
      "description": "Sets active color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconBorderActiveColor": {
      "description": "Sets active color of icon border",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconBorderDefaultColor": {
      "description": "Sets default color of icon border",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "borderDefaultColor": {
      "description": "Sets default color of border around icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "borderActiveColor": {
      "description": "Sets active color of border around icon circle",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "title": {
      "description": "Sets title of icon for accessibility",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "functions": {
      "description": "Button Functions, e.g. { onClick: () => {}}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "linkAttributes": {
      "description": "Link Attributes e.g. { to: \"/\", target: \"_blank\"}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    }
  }
};